
import React from 'react';
import { useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton, PrimaryButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import FileSaver from 'file-saver';
import iconv from 'iconv-lite';

import { getDrupozTitle } from '../../reducers/drupoz';
import { getOpsubName } from '../../reducers/opsub';
import { getParName } from '../../reducers/par';

import OverviewTitle from './OverviewTitle';
import MapDialog from './MapDialog';
import IsknTelesoInfo from './IsknTelesoInfo';

const classNames = mergeStyleSets({
    root: {
        padding: 16
    },
    title: {
        paddingBottom: 16
    },
    content: {
        maxHeight: 800,
        overflowY: 'auto',
        paddingRight: 8,
        marginBottom: 8,
    },
    closeIcon: {

    }
});

function getAnalyzeResultAsCsv(analyzeResult, drupozState) {
    let content = [];
    content.push([`par_id;katuze_kod;katuze_nazev;parcela;partype;vymera;drupoz;lv;vlastnik`]);

    analyzeResult.par.forEach(item => {

        let tel = analyzeResult.tel.reduce((previous, current) => {
            return (current.tel_id === item.tel_id)
                ? current
                : previous;
        }, null);

        let vlastnikItems = [];
        analyzeResult.vla.forEach(vla => {
            if (vla.tel_id === tel.tel_id) {
                analyzeResult.opsub.forEach(opsub => {
                    if (opsub.opsub_id === vla.opsub_id) {
                        const typrav = (vla.typrav_kod !== '30') ? '*' : '';
                        vlastnikItems.push(
                            `${getOpsubName(opsub)} (${vla.podil_citatel}/${vla.podil_jmenovatel})${typrav}`
                        );
                    }
                });
            }
        });

        let vlastnik = vlastnikItems.join(';');

        let items = [];
        items.push(item.par_id);
        items.push(item.katuze_kod);
        items.push(item.katuze_name);
        items.push(getParName(item));
        items.push(item.par_type);
        items.push(item.vymera_parcely);
        items.push(getDrupozTitle(drupozState, item.drupoz_kod));
        items.push(tel.cislo_tel);
        items.push(vlastnik);
        content.push(items.join(';'));
    });

    return iconv.encode(content.join('\r\n'), 'win1250');
}


const AnalyzeResultPanel = ({analyzeResult, isknDateTitle, open, onDismiss}) => {

    const [parItemInMap, setParItemInMap] = React.useState(null);
    const drupozState = useSelector(state => state.drupoz);

    const handleExportCsv = () => {
        let content = getAnalyzeResultAsCsv(analyzeResult, drupozState);
        let blob = new Blob([content], {type: 'text/csv;charset=windows-1250;'});
        FileSaver.saveAs(blob, 'lv.csv');
    }

    const handleShowInMap = (parItem) => {
        setParItemInMap(parItem);
    }

    const handleDismissMap = () => {
        setParItemInMap(null);
    }

    return (
        <Modal
            className={classNames.root}
            isOpen={open}
            isModeless={false}
            isDarkOverlay={true}
            dragOptions={false}
            onDismiss={onDismiss}
        >
            <Stack className={classNames.root}>
                <Stack horizontal className={classNames.title}>
                    <Stack.Item grow>
                        <OverviewTitle title={`Informace o vlastnictví z "${isknDateTitle}"`} />
                    </Stack.Item>
                    <IconButton
                        styles={classNames.closeIcon}
                        iconProps={{iconName: 'Cancel'}}
                        ariaLabel="Zavřít"
                        onClick={onDismiss}
                    />
                </Stack>
                <Stack.Item className={classNames.content}>
                    {analyzeResult.tel.map(item => {
                        return (
                            <IsknTelesoInfo
                                key={item.tel_id}
                                data={analyzeResult}
                                tel={item}
                                onShowInMap={handleShowInMap}
                            />
                        );
                    })}
                </Stack.Item>
                <Stack horizontal reversed tokens={{childrenGap: 8}}>
                    <PrimaryButton text="Zavřít" onClick={onDismiss} />
                    <DefaultButton text="Export do CSV" onClick={handleExportCsv} />
                </Stack>
                <MapDialog
                    open={!!parItemInMap}
                    onDismiss={handleDismissMap}
                    parItem={parItemInMap}
                />
            </Stack>
        </Modal>
    );
}

export default AnalyzeResultPanel;
